<template>
    <MainContent>
      <b-row>
        <b-col cols="12" md="6">
          <LoginWelcomBanner />
          <!-- <LCGEBanner /> -->
        </b-col>
        <b-col cols="12" md="6">
          <LoginForm />
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col cols="7"></b-col>
        <b-col cols="5">
          <nx-bform>
            <div class="right-panel">
              <i
                class="fas fa-exclamation-triangle"
                style="font-size: 1.2rem"
              ></i>
              <h5 class="px-3 mb-0">{{ $t("complaint") }}</h5>
            </div>
          </nx-bform>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col cols="7">
          <InfoNewsTable />
        </b-col>
        <b-col cols="5">
          <NewFeaturesTable />
          <OnlineTutorialsTable />
        </b-col>
      </b-row>
    </MainContent>
    <!-- <FooterMenu /> -->
    <!-- <FooterLink /> -->
    <!-- <FooterIcon /> -->
</template>

<script>
import InfoNewsTable from "@/components/info/InfoNewsTable";
import OnlineTutorialsTable from "@/components/info/OnlineTutorialsTable";
import NewFeaturesTable from "@/components/info/NewFeaturesTable";
import { UserApi } from "nx-libs";
import MainContent from "../../../components/main/MainContent";
import LoginWelcomBanner from "../components/login/LoginWelcomBanner";
// import LCGEBanner from "../components/login/LCGEBanner";
import LoginForm from "../components/login/LoginForm";
import FooterMenu from "@/parts/footer/FooterMenu";
import FooterLink from "@/parts/footer/FooterLink";
import FooterIcon from "@/parts/footer/FooterIcon";

export default {
  // metaInfo: {title: 'Login'},
  components: {
    LoginWelcomBanner,
    LoginForm,
    // LCGEBanner,
    InfoNewsTable,
    OnlineTutorialsTable,
    NewFeaturesTable,
    MainContent,
    FooterMenu,
    FooterLink,
    FooterIcon
  },
  async created() {
    try {
      const {data:user} = await UserApi.getCurrentUser();
      if(user.loginName!="dummy_for_owner")
        window.location.href = process.env.VUE_APP_ESS_URL;
    } catch (e) {}
  },
  mounted() {
    this.$nextTick(() => {
      // 創建一個 MutationObserver 實例
      const observer = new MutationObserver((mutations) => {
        const trElements = document.querySelectorAll('table tr');
        trElements.forEach(tr => {
          if (tr.hasAttribute('role')) {
            tr.removeAttribute('role');
          }
        });


        // 查找目标按钮
        const buttons = document.querySelectorAll('button.page-link');
        // 遍历按钮并调整样式
        buttons.forEach(button => {
          button.style.backgroundColor = "rgb(0, 85, 204)"; // 深蓝色
          button.style.color = "rgb(255, 255, 255)"; // 白色
        });


      });
      // 配置觀察選項
      const config = {
        attributes: true,
        childList: true,
        subtree: true
      };
      // 開始觀察
      const targetNode = document.querySelector('.dataTable');
      if (targetNode) {
        observer.observe(targetNode, config);
      }
      // 組件銷毀時斷開觀察
      this.$once('hook:beforeDestroy', () => {
        observer.disconnect();
      });
    });
  }
};
</script>

<i18n>
{
  "en": {
    "complaint": "Complaint / Report"
  },
  "zh_hk": {
    "complaint": "投訴 / 舉報"
  },
  "zh_cn": {
    "complaint": "投诉 / 举报"
  }
}
</i18n>